import {
  can,
} from "../../shared/auth/access";
import {
  TableState,
} from "../../shared/components/TableState";
import type {
  useSuppliersWorkspace,
} from "./useSuppliersWorkspace";

export function SupplierContacts({ model }: { model: ReturnType<typeof useSuppliersWorkspace> ;}) {
  const { user, supplierTab, supplierAction, setSupplierAction, supplierActionPending, contactForm, setContactForm, selectedSupplier, contactRoleLabels, priorityLabels, addContact, verifyContact } = model;
  if (!selectedSupplier) return null;
  return (<>{supplierTab === "contacts" ? (
    <>
      <div className="data-table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Kişi</th>
              <th>Rol</th>
              <th>Öncelik</th>
              <th>E-posta</th>
              <th>Doğrulama</th>
            </tr>
          </thead>
          <tbody>
            {(selectedSupplier.contacts ?? []).map(
              (contact) => (
                <tr
                  key={
                    contact.id ??
                    `${contact.role}-${contact.email}`
                  }
                >
                  <td>{contact.fullName}</td>
                  <td>{contactRoleLabels[contact.role]}</td>
                  <td>{priorityLabels[contact.priority]}</td>
                  <td>{contact.email}</td>
                  <td>
                    {contact.emailVerified ? (
                      "Doğrulandı"
                    ) : (
                      <button
                        className="secondary-button"
                        disabled={
                          supplierActionPending ||
                          !can(user, "supplier.contact.manage")
                        }
                        onClick={() =>
                          verifyContact(contact.id)
                        }
                      >
                        Yetkili doğrulama
                      </button>
                    )}
                  </td>
                </tr>
              ),
            )}
          </tbody>
        </table>
      </div>
      {!(selectedSupplier.contacts ?? []).length ? (
        <TableState
          title="İletişim kişisi yok"
          description="Teklif, sipariş, kalite veya sözleşme için yetkili kişi ekleyin."
        />
      ) : null}
      {can(user, "supplier.contact.manage") &&
        supplierAction !== "contact" ? (
        <button
          className="primary-button"
          onClick={() => setSupplierAction("contact")}
        >
          İletişim kişisi ekle
        </button>
      ) : null}
      {supplierAction === "contact" ? (
        <div className="supplier-action-drawer">
          <h3>İletişim kişisi ekle</h3>
          <div className="inline-form-grid">
            <label>
              Ad soyad
              <input
                value={contactForm.fullName}
                onChange={(event) =>
                  setContactForm((current) => ({
                    ...current,
                    fullName: event.target.value,
                  }))
                }
              />
            </label>
            <label>
              E-posta
              <input
                type="email"
                value={contactForm.email}
                onChange={(event) =>
                  setContactForm((current) => ({
                    ...current,
                    email: event.target.value,
                  }))
                }
              />
            </label>
            <label>
              Rol
              <select
                value={contactForm.role}
                onChange={(event) =>
                  setContactForm((current) => ({
                    ...current,
                    role: event.target.value,
                  }))
                }
              >
                <option value="RFQ">Teklif</option>
                <option value="ORDER">Sipariş</option>
                <option value="QUALITY">Kalite</option>
                <option value="CONTRACT">Sözleşme</option>
              </select>
            </label>
            <label>
              Öncelik
              <select
                value={contactForm.priority}
                onChange={(event) =>
                  setContactForm((current) => ({
                    ...current,
                    priority: event.target.value,
                  }))
                }
              >
                <option value="PRIMARY">Birincil</option>
                <option value="BACKUP">Yedek</option>
              </select>
            </label>
          </div>
          <div className="inline-form-actions">
            <button
              className="secondary-button"
              onClick={() => setSupplierAction(null)}
            >
              Vazgeç
            </button>
            <button
              className="approve-button"
              disabled={
                supplierActionPending ||
                !can(user, "supplier.contact.manage")
              }
              onClick={addContact}
            >
              Kaydet
            </button>
          </div>
        </div>
      ) : null}
    </>
  ) : null}</>);
}
